(function($) {

  $(document).ready(function() {
  var dir = "down",
      current = 0;
  // Fixed top navigation for desktop browsers
  if($('#navigation').length) {
    var min = 62,
        fix_navi = function() {
          var scrollTop = $(window).scrollTop();
          if(scrollTop > current) {
            dir = "down";
          } else {
            dir = "up";
          }
          current = scrollTop;

        	if(scrollTop > min ) {
        	  $('#masthead').addClass('fixed');
        	}
          else {
            $('#masthead').removeClass('fixed');
          }
        },
        offset = 0;

    $(window).scroll(function() {
   	  fix_navi();
    });

    $(window).resize(function() {
      fix_navi();
    });
  }
  });

  $('body').localScroll({
    offset: {
      left: 0,
      top: -80
    },
    duration: 200,
    hash: true
  });

  $('.value-slider').unslider({
    nav: false,
    animation: 'fade',
    animateHeight: true
  });

  /* Youtube lazyload */
  $('.youtube-link').on('click', function(e) {
    e.preventDefault();

    var iframe = document.createElement("iframe");
    iframe.setAttribute("src", "//www.youtube.com/embed/" + this.parentNode.dataset.id + "?autoplay=1&showinfo=0&modestbranding=1&controls=2&color=white");
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("id", "youtube-iframe");
    this.parentNode.replaceChild(iframe, this);
  });

  // $('.video-wrapper').fitVids();

})(jQuery);

function getBrowserScrollSize(){

    var css = {
        "border":  "none",
        "height":  "200px",
        "margin":  "0",
        "padding": "0",
        "width":   "200px"
    };

    var inner = $("<div>").css($.extend({}, css));
    var outer = $("<div>").css($.extend({
        "left":       "-1000px",
        "overflow":   "scroll",
        "position":   "absolute",
        "top":        "-1000px"
    }, css)).append(inner).appendTo("body")
    .scrollLeft(1000)
    .scrollTop(1000);

    var scrollSize = {
        "height": (outer.offset().top - inner.offset().top) || 0,
        "width": (outer.offset().left - inner.offset().left) || 0
    };

    outer.remove();
    return scrollSize;
}

var Modal = (function(window, undefined) {
  function Modal(el) {
    this._wrap = el;
    this._buttonwrap = $(el).find('.modal-button-container')[0];
    this._button = $(el).find('.modal-button')[0];
    this._outer = $(el).find('.modal-outer-container')[0];
    this._container = $(el).find('.modal-container')[0];
    this._content = $(el).find('.modal-content')[0];
    this._close = $(el).find('.close')[0];


    this.isOpen = false;
    this._TL = null;
  }

  Modal.prototype.open = function() {
    this._TL = new TimelineLite();

    // modalbg
    var showOverlay = this._showOverlay();

    // float
    var floatContainer = this._floatContainer();

    this._TL.add(floatContainer, 0);
    this._TL.add(showOverlay, 0.5);

    this._TL.play();

    this.isOpen = true;

    return this._TL;
  };

  Modal.prototype._showOverlay = function() {
    var TL = new TimelineLite();

    var mbg = $('.modal-bg');

//    TL.set(mbg[0], {display: 'block'});

    mbg.css('display', 'block');

    TL.to(mbg[0], 1, {
      className: '+=active'
    });

    return TL;
  };

  Modal.prototype._floatContainer = function() {
    var TL = new TimelineLite();

    // Flip button

    TL.set(this._buttonwrap, {perspective:500});

    TL.to(this._button, 0.3, {
      rotationX: 180,
      className: '+=rotated',
    });

    scrollBar = getBrowserScrollSize();

    $(document.body).addClass('of-hidden');


    var rect = this._button.getBoundingClientRect();
    var windowW = window.innerWidth;
    var windowH = window.innerHeight;
    var modalW = Math.min(windowW, 800);
    var modalH = this._content.getBoundingClientRect().height;

    TL.set(this._outer, {
      className: '+=expanded',
    });

    TL.set(this._container, {
      width: rect.width,
      height: rect.height,
      x: rect.left + 1,
      y: rect.top + 1,
      position: 'fixed',
      overflow: 'hidden',
    });


    TL.to(this._container, 0.8, {
      width: modalW,
      height: modalH,
      x: Math.max(Math.round((windowW - modalW) / 2), 20),
      y: Math.max(Math.round((windowH - modalH) / 2), 20),
      ease: Expo.easeInOut,
      className: '+=expanded',
    });

    TL.set(this._container, {
      position: 'relative',
    });

    TL.to(this._button, 0.5, {
      css: {opacity: 0},
    }, '-=1.0');


    TL.to(this._content, 0.5, {
      css: {opacity: 1},
    }, '-=0.3');

    TL.to(this._close, 0.5, {
      css: {top: 0},
    }, '-=1');

    return TL;
  };


  Modal.prototype.close = function() {
    this._TL.eventCallback('onReverseComplete', function() {

      TweenLite.set(this._container, {
        clearProps: 'all'
      });


      $(document.body).removeClass('of-hidden');
      var mbg = $('.modal-bg');
      mbg.css('display', 'none');

      this.isOpen = false;

    }.bind(this));

    return this._TL.reverse();
  };

  return Modal;

})(window);



var Stefan = (function(window, undefined) {
  function Stefan(id, el) {
    this._container = $('.stefan-container')[0];

    this.isOpen = false;
    this._TL = null;
  }

  Stefan.prototype.open = function() {
    this._TL = new TimelineLite();

    // modalbg
    var showOverlay = this._showOverlay();

    // float
    var floatContainer = this._floatContainer();

    var containerTweak = this._containerTweak();

    // hide btn

    // content in
    var contentIn = this._contentIn();


    // close modal btn


    this._TL.add(floatContainer, 0);
    this._TL.add(containerTweak, 0.5);
    this._TL.add(showOverlay, 0.5);
    this._TL.add(contentIn, 1);

    this._TL.play();

    this.isOpen = true;

    return this._TL;
  };

  Stefan.prototype._showOverlay = function() {
    var TL = new TimelineLite();

    var mbg = $('.modal-bg');

    mbg.css('display', 'block');

    TL.to(mbg[0], 1, {
      className: '+=active'
    });

    return TL;
  };

  Stefan.prototype._floatContainer = function() {

    $(document.body).addClass('of-hidden');

    var TL = new TimelineLite();

    var rect = this._container.getBoundingClientRect();
    var windowW = window.innerWidth;

    $(this._container).parent().css('min-height', $(this._container).height());

    TL.set(this._container, {
      width: rect.width,
      height: rect.height,
      x: rect.left,
      y: rect.top,
      position: 'fixed',
      overflow: 'hidden'
    });

    TL.to(this._container, 1.5, {
      width: windowW,
      height: '100%',
      x: windowW / 2,
      y: 0,
      xPercent: -50,
      ease: Expo.easeInOut,
      className: '+=expanded',
    });
    return TL;
  };

  Stefan.prototype._containerTweak = function() {
    var TL = new TimelineLite();

    TL.to(this._container, 0.2, {
      css: {paddingTop: "4em", paddingBottom: "4em"},
    });

    return TL;
  };

  Stefan.prototype._contentIn = function() {
    var TL = new TimelineLite();

    var cont = $(this._container).find('.full-content')[0];

    TL.set(cont,{height:'auto'})
      .from(cont, 1.5, { height: 0 });

    TL.to($('#stefan-close')[0], 0.5, {
      css: {top: 0},
    }, '-=0.8');

    return TL;
  };


  Stefan.prototype.close = function() {
    this._TL.eventCallback('onReverseComplete', function() {

      TweenLite.set(this._container, {
        clearProps: 'all'
      });

      $(document.body).removeClass('of-hidden');
      var mbg = $('.modal-bg');
      mbg.css('display', 'none');

      this.isOpen = false;

    }.bind(this));

    return this._TL.reverse();
  };

  return Stefan;

})(window);

var Ceo = (function(window, undefined) {
  function Ceo(id, el) {
    this._container = $('.ceo-inner-wrap')[0];

    this.isOpen = false;
    this._TL = null;
  }

  Ceo.prototype.open = function() {
    this._TL = new TimelineLite();

    // modalbg
    var showOverlay = this._showOverlay();

    // float
    var floatContainer = this._floatContainer();

    var containerTweak = this._containerTweak();

    // hide btn

    // content in
    var contentIn = this._contentIn();


    // close modal btn


    this._TL.add(floatContainer, 0);
    this._TL.add(containerTweak, 0);
    this._TL.add(showOverlay, 0);
    this._TL.add(contentIn, 0);

    this._TL.play();

    this.isOpen = true;

    return this._TL;
  };

  Ceo.prototype._showOverlay = function() {
    var TL = new TimelineLite();

    var mbg = $('.modal-bg');

    mbg.css('display', 'block');

    TL.to(mbg[0], 1, {
      className: '+=active'
    });

    return TL;
  };

  Ceo.prototype._floatContainer = function() {

    $(document.body).addClass('of-hidden');

    var TL = new TimelineLite();

    var rect = this._container.getBoundingClientRect();
    var windowW = window.innerWidth;

    $(this._container).parent().css('min-height', $(this._container).height());

    TL.set(this._container, {
      width: rect.width,
      height: rect.height,
      x: rect.left,
      y: rect.top,
      position: 'fixed',
      overflow: 'hidden'
    });

    TL.to(this._container, 0.5, {
      width: windowW,
      height: '100%',
      x: windowW / 2,
      y: 0,
      xPercent: -50,
      ease: Expo.easeInOut,
      className: '+=expanded',
    });
    return TL;
  };

  Ceo.prototype._containerTweak = function() {
    var TL = new TimelineLite();

    TL.to(this._container, 0.2, {
      css: {paddingTop: "4em", paddingBottom: "4em"},
    });

    return TL;
  };

  Ceo.prototype._contentIn = function() {
    var TL = new TimelineMax();

    var cont = $(this._container).find('.full-content')[0];
    var teas = $(this._container).find('.teaser-content')[0];

    TL.set(teas,{height:'auto'})
      .to(teas, 0.6, { height: 0 });

    TL.set(cont,{height:'auto'})
      .from(cont, 1, { height: 0 }, '-=0.9');

    TL.to($('#ceo-close')[0], 0.5, {
      css: {top: 0},
    }, '-=0.8');

    return TL;
  };


  Ceo.prototype.close = function() {
    this._TL.eventCallback('onReverseComplete', function() {

      TweenLite.set(this._container, {
        clearProps: 'all'
      });

      $(document.body).removeClass('of-hidden');
      var mbg = $('.modal-bg');
      mbg.css('display', 'none');

      this.isOpen = false;

    }.bind(this));

    return this._TL.reverse();
  };

  return Ceo;

})(window);

(function($) {
  $.fn.escape = function (callback) {
      return this.each(function () {
          $(document).on("keydown", this, function (e) {
              var keycode = ((typeof e.keyCode !=='undefined' && e.keyCode) ? e.keyCode : e.which);
              if (keycode === 27) {
                  callback.call(this, e);
              }
          });
      });
  };

  $(document).ready(function() {
    $('.modal-outer-wrap').each(function(i, el) {
      var modal = new Modal(el);

      $(this).find('.button').first().on('click', function(e) {
        e.preventDefault();
        modal.open();
      });

      $(this).find('.close').first().on('click', function(e) {
        e.preventDefault();
        modal.close();
      });

      $(this).find('.modal-outer-container').on('click', function(e) {
        if($(e.toElement).hasClass('modal-outer-container') && modal.isOpen) {
          modal.close();
        }
      });

      $(this).escape(function() {
        if(modal.isOpen) {
          modal.close();
        }
      });

    });

    var j = new Ceo();

    $('#ceo-open').on('click', function(e) {
      e.preventDefault();
      j.open();
    });

    $('#ceo-close').on('click', function(e) {
      e.preventDefault();
      j.close();
    });

    $('.ceo-inner-wrap').on('click', function(e) {
      if($(e.toElement).hasClass('expanded')) {
        j.close();
      }
    });

    var s = new Stefan();

    $('#stefan-open').on('click', function(e) {
      e.preventDefault();
      s.open();
    });

    $('#stefan-close').on('click', function(e) {
      e.preventDefault();
      s.close();
    });

    $('.stefan-container').on('click', function(e) {
      if($(e.toElement).hasClass('expanded')) {
        s.close();
      }
    });
  });
})(jQuery);

/**
  * Featured slider
  */
(function($) {
  $(document).ready(function() {
    var coords = [
      {
        'left': [
          [0, 430],
          [0, 0],
          [1111, 0],
          [1111, 430]
        ],
        'active': [
          [0, 439],
          [0, 0],
          [1111, 0],
          [1111, 439]
        ],
        'right': [
          [0, 430],
          [0, 0],
          [1111, 0],
          [1111, 430]
        ]
      },
      {
        'leftleft': [
          [0, 483],
          [0, 0],
          [765, 0],
          [682, 437]
        ],
        'left': [
          [0, 483],
          [0, 0],
          [765, 0],
          [632, 437]
        ],
        'active': [
          [0, 483],
          [0, 0],
          [885, 0],
          [752, 437]
        ]
      },
      {
        'active': [
          [60,440],
          [17,0],
          [903,0],
          [903,483]
        ],
        'right': [
          [38,463],
          [175,0],
          [903,0],
          [600,483]
        ],
        'rightright': [
          [38,463],
          [80,0],
          [903,0],
          [240,483]
        ]
      }
    ];

    function animateSlides(from, to) {
       var mainTL = new TimelineMax({
         onComplete: function(t) { mainTL.kill(); }
       });

      for(var i = 0; i < 3; i++) {
        var TL = new TimelineMax();

        var ind = i+1;

        TL.add(TweenLite.to($('#slide-'+ind+',#slide-'+ind+'-link'), 0.01, {
          className: to[i],
        }, 0));

        var start = coords[i][from[i]];
        var end = coords[i][to[i]];

        var points = [];
        $.each(end, function(i, e) { points.push(e.join()); });

        TL.add(TweenMax.to($('.slide-'+ind+'-clip'), 0.5, {
          attr: {
            points: points.join(' ')
          }
        }, 0));

        mainTL.add(TL, 0);
      }

      mainTL.play();

    }


    // Slide 1 clicks
    $('#slide-1-link').on('click', function(e) {
      e.preventDefault();
      var from = [];

      if($('#slide-2').hasClass('active')) {
        // Slide 2 active
        from = ['right', 'active', 'rightright'];
      } else {
        // Slide 3 active
        from = ['left', 'leftleft', 'active'];
      }

      var to = ['active', 'left', 'right'];

      animateSlides(from, to);
    });


    // Slide 2 clicks
    $('#slide-2-link').on('click', function(e) {
      e.preventDefault();
      var from = [];

      if($('#slide-1').hasClass('active')) {
        // Slide 1 active
        from = ['active', 'left', 'right'];
      } else {
        // Slide 3 actve
        from = ['left', 'leftleft', 'active'];
      }

      var to = ['right', 'active', 'rightright'];

      animateSlides(from, to);
    });


    // Slide 3 clicks
    $('#slide-3-link').on('click', function(e) {
      e.preventDefault();
      var from = [];

      if($('#slide-1').hasClass('active')) {
        // Slide 1 active
        from = ['active', 'left', 'right'];
      } else {
        // Slide 2 active
        from = ['right', 'active', 'rightright'];
      }

      var to = ['left', 'leftleft', 'active'];

      animateSlides(from, to);
    });

  });

  // $('.video').YTPlayer({
  //  fitToBackground: true,
  //  videoId: 'LSmgKRx5pBo'
  // });

})(jQuery);
